/**
 * Finalised stock take item storage (chunked layout only).
 *
 * Backend / store service reads {@link IStockTake.finalisedStorageSchema} on the stock take
 * document and `finalisedStorageSchema` on the STOCK_TAKE from_app message payload.
 */
export const STOCK_TAKE_FINALISED_STORAGE_SCHEMA = 2;

/** Alias used when writing new stock takes. */
export const STOCK_TAKE_FINALISED_STORAGE_SCHEMA_CURRENT = STOCK_TAKE_FINALISED_STORAGE_SCHEMA;

/** STOCK_TAKE message `payload.data` extension. */
export const STOCK_TAKE_MESSAGE_TYPE = 'STOCK_TAKE' as const;
